export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_LOADING = 'USER_LIST_LOADING';
export const USER_LIST_FAILED = 'USER_LIST_FAILED';
export const USER_LIST_LOAD = 'USER_LIST_LOAD';
